export default "__VITE_ASSET__BNH7cFL8__"